module.exports = __webpack_public_path__ + "static/media/M151B.5ee85cfa.PNG";